import moment from 'moment';

export const printInfo = info => {
  if (typeof info === 'undefined' || info === null || info.length === 0) {
    return '-';
  } else {
    return info;
  }
};

export const getFullDateTimeWithSeconds = date => {
  if (date == null) {
    return '-';
  } else {
    //console.log(date);
    const dt = Date.parse(date);
    if (isNaN(dt)) return '-';
    else return moment(dt).local().format('DD/MM/YYYY HH:mm:ss');
  }
};

export function mapApptrackDetails(apiData, currentState) {
  // const mappedDocuments = (apiData.documents || []).reduce((acc, doc) => {
  //   if (doc.field) acc[doc.field] = doc;
  //   return acc;
  // }, {});
  const terms = apiData.terms;
  const variablesIndexed = {
    submissionDate: apiData.submittedOn,
    abiGcrCode: apiData.companyDetails.gemiNumber,
    legalVat: apiData.companyDetails.taxId,
    companyName: apiData.companyDetails.companyName,
    legalPhoneMobile: apiData.companyDetails.contactPhone,
    legalEmail: apiData.companyDetails.contactEmail,
    bnkBank: apiData.bank,
    description: apiData.investmentPlan.investmentPlanDetails.description,
    parseFlag: apiData.parseFlag,
    beneficialOwners: apiData.beneficialOwners,
    fundingPrograms: apiData.fundingPrograms,
    dapanesEpendysis: JSON.stringify({
      ependutikoSxedio: {
        titlos: apiData.investmentPlan.investmentPlanDetails.title,
        kwdikosKad:
          apiData.investmentPlan.investmentPlanDetails.activityDescription,
        topos: apiData.investmentPlan.investmentPlanDetails.location,
        enarksh: apiData.investmentPlan.investmentPlanDetails.startedOn,
        oloklhrwsh: apiData.investmentPlan.investmentPlanDetails.completedOn,
        perigrafi: apiData.investmentPlan.investmentPlanDetails.description,
      },
    }),
    loan: apiData.fundingScheme.loan.amount,
    loanPercentage: apiData.fundingScheme.loan.percentage,
    commercialLoan: apiData.fundingScheme.participation.amount,
    commercialLoanPercentage: apiData.fundingScheme.participation.percentage,
    totalEstimate: apiData.fundingScheme.subsidy.amount,
    totalEstimatePercentage: apiData.fundingScheme.subsidy.percentage,
    total: apiData.fundingScheme.total.amount,
    totalPercentage: apiData.fundingScheme.total.percentage,
  };

  const contentItems = Object.values({
    businessPlanFile: apiData.businessPlan?.businessPlan,
    eligibilityFile: apiData.businessPlan?.eligibility,
    financialModelFile: apiData.businessPlan?.financialModel,
    ...apiData.documents,
  }).filter(item => item !== null);

  const stateData = {
    ...currentState,
    apptrackDetails: {
      activeTaskName: apiData.activeTaskId,
      ...currentState?.appTrack?.apptrackDetails,
      variablesIndexed: variablesIndexed,
      contentItems,
      terms,
    },
  };
  return stateData;
}

export const documentFieldTitlesMapper = {
  BusinessPlan: 'Επιχειρηματικό σχέδιο',
  Eligibility: 'Αρχείο επιλεξιμότητας',
  investmentExpenditures:
    'Συμπληρωμένο σε Ηλεκτρονική Μορφή Excel "Δαπάνες Επένδυσης"',
  accumulationDeclaration: 'Υπεύθυνη Δήλωση Σώρευσης',
  taxFormE3: 'Φορολογικό Έντυπο Ε3',
  beneficialOwnersDeclaration:
    'Υπεύθυνη Δήλωση Στοιχείων Πραγματικών Δικαιούχων',
  beneficialOwnersRegistryPrintout:
    'Eκτύπωση από το Κεντρικό Μητρώο Πραγματικών Δικαιούχων',
  gemiChangesCertificate: 'Πιστοποιητικό Μεταβολών ΓΕΜΗ',
  otherDocuments: 'Άλλα Δικαιολογητικά',
};

export function mapDocuments(sourceData) {
  const groupedByField = sourceData.reduce((accumulator, currentValue) => {
    if (!accumulator[currentValue.field]) {
      accumulator[currentValue.field] = [];
    }
    accumulator[currentValue.field].push(currentValue);
    return accumulator;
  }, {});

  const result = Object.entries(groupedByField).map(([field, items]) => ({
    title: documentFieldTitlesMapper[field] || field,
    items: items.map(item => ({
      id: item.contentItemId,
      name: item.name,
      contentAvailable: true,
      contentStoreId: item.contentStoreId,
      contentStoreName: 'INTERNAL_FILE',
      mimeType: item.mimeType,
      simpleType: item.mimeType === 'application/pdf' ? 'pdf' : 'unknown',
      field: item.field,
      created: item.createdAt,
      createdBy: item.createdBy || null,
      size: item.contentSize,
    })),
  }));

  return result;
}
